<template>
    <div class="accordion" role="tablist">
        <b-tabs>
            <b-tab title="General">
                <validation-observer v-slot="{ passes }" slim>
                    <div class="col-md-8">
                        <b-container class="p-4">
                            <b-row class="m-3">
                                <b-col class="col-4">Email Address:</b-col>
                                <b-col class="col-7">
                                    <validation-provider rules="email" name="Email" v-slot="{ valid, errors }" mode="eager" slim>
                                        <b-form-input name="notificationEmailRecipient"
                                                      v-model="notificationEmailRecipient"
                                                      :state="errors[0] ? false : null">
                                        </b-form-input>
                                        <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
                                    </validation-provider>
                                </b-col>
                                <b-col class="col-1"></b-col>
                            </b-row>
                            <b-row class="m-3">
                                <b-col class="col-4">Time zone:</b-col>
                                <b-col class="col-7"><b-form-input v-model="profileTimezone" readonly></b-form-input></b-col>
                                <b-col class="col-1"><b-link :href="userProfileUrl" size="lg" class="align-bottom">Change</b-link></b-col>
                            </b-row>
                            <b-row class="m-3">
                                <b-col class="col-4">Notification Email Summary Delivery Time:</b-col>
                                <b-col class="col-4">
                                    <b-form-input ref="startTimeInput"
                                                  name="startTime"
                                                  type="time"
                                                  v-model="summaryEmailDeliveryTime">
                                    </b-form-input>
                                </b-col>
                                <b-col class="col-4"></b-col>
                            </b-row>
                        </b-container>

                        <!--TOPSDEV-3521 Hide the notification setting toggle switch in the Notification Setting-->
                        <!--<b-container class="p-4">
                            <b-row class="m-3"><b-col><b-checkbox switch v-model="enableNotifications"></b-checkbox></b-col><b-col>Enable notifications</b-col><b-col></b-col></b-row>-->
                            <!--<b-row class="m-3"><b-col><b-checkbox switch v-model="enableNotificationSound"></b-checkbox></b-col><b-col>Enable notification sound</b-col><b-col></b-col></b-row>-->
                            <!--b-row class="m-3"><b-col><b-checkbox switch v-model="autoDeleteNotifications"></b-checkbox></b-col><b-col>Auto-delete notifications</b-col><b-col></b-col></b-row>-->
                        <!--</b-container>-->

                        <div class="float-right">
                            <b-button v-on:click="passes(saveGeneralNotificationSettings)" variant="success">SAVE</b-button>
                        </div>
                    </div>
                </validation-observer>
            </b-tab>

            <b-tab :title="notificationSetting.eventSourceTypeDisplayName + ' Notifications'" v-for="notificationSetting in notificationSettings" :key="notificationSetting.eventSourceTypeEnum">
                <div style="border: 1px solid #ccc; margin: 10px; padding: 5px;" v-for="eventCategory in notificationSetting.eventCategories" :key="eventCategory.eventCategoryEnum">
                    <b-button block v-b-toggle="'accordion_'  + notificationSetting.eventSourceTypeEnum + '_' + eventCategory.eventCategoryEnum" variant="info">Category: {{ eventCategory.eventCategoryDisplayName }}</b-button>
                    <b-collapse :id="'accordion_'  + notificationSetting.eventSourceTypeEnum + '_' + eventCategory.eventCategoryEnum" :accordion="'accordion_'  + notificationSetting.eventSourceTypeEnum" role="tabpanel" class="pb-5">
                       
                            <b-table small :fields="fields" :items="eventCategory.events" responsive="sm">
                                <template #cell(active)="row">
                                    <b-checkbox switch v-model="row.item.active" :disabled="row.item.eventEnum==23 || row.item.eventEnum==24 "></b-checkbox>
                                </template>
                                <template #cell(immediateEmailToDaysUntilDue)="row">
                                    <b-select :options="timeSlotOptions" v-model="row.item.immediateEmailToDaysUntilDue"></b-select>
                                </template>
                                <template #cell(summaryEmailToDaysUntilDue)="row">
                                    <b-select :options="timeSlotOptions" v-model="row.item.summaryEmailToDaysUntilDue"></b-select>
                                </template>
                            </b-table>
                        <div class="float-right pr-2">
                            <b-button v-on:click="saveNotificationBlock(eventCategory)" variant="success">SAVE</b-button>
                        </div>
                    </b-collapse>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>

    import Vue from 'vue';
    import BootstrapVue from 'bootstrap-vue';
    import axios from 'axios';
    import { DateTimePickerPlugin } from '@syncfusion/ej2-vue-calendars';

    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { extend, localize } from 'vee-validate';
    import { email } from 'vee-validate/dist/rules';
    import en from 'vee-validate/dist/locale/en.json';
    extend('email', email);
    localize('en', en);

    import ErrorsMixin from '../mixins/ErrorsMixin';
    import DateTimeMixin from '../mixins/DateTimeMixin';

    Vue.use(BootstrapVue);
    Vue.use(DateTimePickerPlugin);
    Vue.component('validation-provider', ValidationProvider);
    Vue.component('validation-observer', ValidationObserver);

    export default {
        name: 'NotificationSettings',
        mixins: [DateTimeMixin, ErrorsMixin],
        props: {

            apiBaseUrl: {
                type: String,
                required: true
            },
            userProfileUrl: {
                type: String,
                required: true
            },
            profileTimezone: {
                type: String,
                default: null,
            }
        },

        data: function () {

            return {
                notificationEmailRecipient: null,
                summaryEmailDeliveryTime: null,
                enableNotifications: true,
                enableNotificationSound: null,
                autoDeleteNotifications: true,
                notificationSettings: null,
                selectedTimeSlot: 0,
                fields: [
                    { key: 'active', label: 'off/on' },
                    { key: 'eventDisplayName', label: 'When status changes to ...' },
                    { key: 'immediateEmailToDaysUntilDue', label: 'Immediate email', class: 'text-center' },
                    { key: 'summaryEmailToDaysUntilDue', label: 'Summary email', class: 'text-center' }
                ],
                timeSlotOptions: [
                    { value: -1, text: 'NO NOTIFICATION' },
                    { value: 1, text: 'up to 1 day' },
                    { value: 2, text: 'up to 2 days' },
                    { value: 3, text: 'up to 3 days' },
                    { value: 4, text: 'up to 4 days' },
                    { value: 5, text: 'up to 5 days' },
                    { value: 999999, text: 'ALWAYS' }
                ]
            }
        },

        methods: {

            loadNotificationSettings: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'Notification/list/notificationsubscription';

                return axios
                    .get(url)
                    .then(response => {
                        this.notificationSettings = response.data;
                        console.log(JSON.stringify(this.notificationSettings));
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            loadGeneralNotificationSettings: function () {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'UserProfile';
                
                return axios
                    .get(url)
                    .then(response => {
                        console.log(response.data);
                        if ('NotificationEmailRecipient' in response.data) this.notificationEmailRecipient = response.data.NotificationEmailRecipient;
                        if ('EnableNotifications' in response.data) this.enableNotifications = true; //response.data.EnableNotifications; //this.enableNotifications, //TOPSDEV-3521
                        if ('EnableNotificationSound' in response.data) this.enableNotificationSound = response.data.EnableNotificationSound;
                        if ('AutoDeleteNotifications' in response.data) this.autoDeleteNotifications = response.data.AutoDeleteNotifications;
                        if ('NotificationSummaryEmailDeliveryTime' in response.data) this.summaryEmailDeliveryTime = this.formatDateTime(response.data.NotificationSummaryEmailDeliveryTime, 'HH:mm', true, true);
                    })
                    .catch(ex => {
                        var currentErrors = this.handleAxiosException(ex);
                        this.showErrorsToast(currentErrors);
                    });
            },

            saveNotificationBlock: function (notificationBlock) {

                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'Notification';

                return axios
                    .post(url, JSON.stringify(notificationBlock),
                        {
                            headers: {
                                'Content-Type': 'application/json'
                            }
                        })
                    .then(() => {
                        this.$bvToast.toast('Notification Settings updated successfully', {
                            title: 'Notification Settings Saved',
                            variant: 'success',
                            appendToast: true
                        });
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },

            saveGeneralNotificationSettings: function () {
                var userProfile = {
                    NotificationEmailRecipient: this.notificationEmailRecipient,
                    EnableNotifications: true, //this.enableNotifications, //TOPSDEV-3521
                    EnableNotificationSound: this.enableNotificationSound,
                    AutoDeleteNotifications: this.autoDeleteNotifications,
                    NotificationSummaryEmailDeliveryTime: this.parseDateTime(this.summaryEmailDeliveryTime, 'HH:mm', true, true)
                };
                var url = this.apiBaseUrl;
                if (!url.endsWith('/')) url += '/';
                url += 'UserProfile';

                axios.put(url, JSON.stringify(userProfile), { headers: { 'Content-Type': 'application/json' } })
                    .then(() => {

                        this.$bvToast.toast('General Notification Settings updated successfully', {
                            title: 'Notification Settings Saved',
                            variant: 'success',
                            appendToast: true
                        });
                        this.loadGeneralNotificationSettings();
                        // use/access the results
                    })
                    .catch(errors => {
                        console.log(errors);
                    });
            }
        }, // methods

        mounted: function () {
            this.loadNotificationSettings();
            this.loadGeneralNotificationSettings();
        }
    } // export default

</script>


 